export default {
      id: "icon-bras-multiple-usage",
      viewBox: "0 0 106.9 133.1",
      url: __webpack_public_path__ + "icons.svg#icon-bras-multiple",
      toString: function () {
        return this.url;
      }
    }